import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTest } from '../../contexts/TestContext';
import { subscribeUserByArea } from '../../services/mailerLiteService';
import { REDIRECT_URLS } from '../../config/credentials';
import './LeadForm.css';

const LeadForm = ({ areaId }) => {
  const { userInfo, setUserInfo, results } = useTest();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validación básica
    if (!userInfo.name.trim() || !userInfo.email.trim()) {
      setError('Por favor, completa todos los campos.');
      return;
    }
    
    // Validación de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(userInfo.email)) {
      setError('Por favor, introduce un email válido.');
      return;
    }
    
    setIsSubmitting(true);
    setError('');
    
    try {
      // Enviar los datos a MailerLite
      await subscribeUserByArea(
        userInfo.email,
        userInfo.name,
        areaId,
        results?.scorePercentage || 0
      );
      
      // Redireccionar a la página de agradecimiento correspondiente
      window.location.href = REDIRECT_URLS[areaId] || '/';
    } catch (err) {
      console.error('Error al suscribir al usuario:', err);
      setError('Ha ocurrido un error. Por favor, inténtalo de nuevo.');
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="lead-form-container">
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <div className="input-icon">👤</div>
          <input
            type="text"
            name="name"
            placeholder="Tu nombre completo"
            value={userInfo.name}
            onChange={handleChange}
            disabled={isSubmitting}
            required
            aria-label="Nombre completo"
            autoComplete="name"
          />
        </div>
        
        <div className="form-group">
          <div className="input-icon">✉️</div>
          <input
            type="email"
            name="email"
            placeholder="Tu correo electrónico"
            value={userInfo.email}
            onChange={handleChange}
            disabled={isSubmitting}
            required
            aria-label="Correo electrónico"
            autoComplete="email"
          />
        </div>
        
        <div className="consent-check">
          <input
            type="checkbox"
            id="consentCheck"
            name="consent"
            required
            aria-label="Aceptar política de privacidad"
          />
          <label htmlFor="consentCheck">
            Acepto la <a href="/politica-privacidad" target="_blank" rel="noopener noreferrer">política de privacidad</a> y el envío de contenido educativo y promocional a mi correo electrónico.
          </label>
        </div>
        
        <motion.button
          type="submit"
          className="submit-button"
          disabled={isSubmitting}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {isSubmitting ? 'Enviando...' : 'DESCARGAR MI GUÍA AHORA'}
        </motion.button>
      </form>
      
      <div className="secure-info">
        <span className="lock-icon">🔒</span>
        <span>Tu información está protegida con encriptación de 256 bits.</span>
      </div>
    </div>
  );
};

export default LeadForm;
